<div class="centered-container" *ngIf="!isSpinLoading else spinner">
	<div *ngIf="!isInValidSessionToken">
	<h1 class="message" translate>email-updated</h1>
	<button type="button" mat-button color="accent" class="action-button" (click)="redirectPortal()"><span
			translate>redirect.portal</span>
	</button>
	</div>
	<div *ngIf="isInValidSessionToken">
		<h1 class="message" translate>email-link-expired</h1>
	</div>
</div>
<ng-template #spinner>
	<div class="centered-container" *ngIf="isInValidSessionToken">
		<h1 translate>email-update</h1>
	</div>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>